<template>
  <div>
    <FlashMessages />
    <NoticeMessage />
    <OverlayLoader />
  </div>
</template>

<script>
import FlashMessages from '@/components/_shared/FlashMessage/FlashMessages.vue'
import NoticeMessage from '@/components/_shared/NoticeMessage/NoticeMessage.vue'
import OverlayLoader from '@/components/_shared/Overlay/OverlayLoader.vue'

export default {
  name: 'Messages',

  components: {
    FlashMessages,
    NoticeMessage,
    OverlayLoader,
  },
}
</script>
